export default class Permissoes implements IPermissoes {
  public ver_analises!: boolean;
  public ver_timeline!: boolean;
  public ver_imposto!: boolean;
  public gerar_darf!: boolean;
  public calcular!: boolean;
  public incluir_nota!: boolean;
  public ver_relatorios!: boolean;
  public buscar!: boolean;
  public gerenciar_usuarios!: boolean;
  public gerenciar_clientes!: boolean;
  public ver_inteligencia!: boolean;

  constructor(param: IPermissoes) {
    Object.assign(this, param);
  }
  public static PermissoesInvestidor() {
    return new Permissoes({
      calcular: true,
      incluir_nota: true,
      ver_analises: true,
      ver_imposto: true,
      ver_relatorios: true,
      ver_timeline: true,
      buscar: true,
      gerar_darf: true,
      gerenciar_clientes: false,
      gerenciar_usuarios: false,
      ver_inteligencia: false,
    });
  }
  public static PermissoesContador() {
    return new Permissoes({
      calcular: true,
      incluir_nota: true,
      ver_analises: true,
      ver_imposto: true,
      ver_relatorios: true,
      ver_timeline: true,
      buscar: true,
      gerar_darf: true,
      gerenciar_clientes: true,
      gerenciar_usuarios: true,
      ver_inteligencia: true,
    });
  }
  public static PermissoesClientePadrao() {
    return new Permissoes({
      calcular: false,
      incluir_nota: true,
      ver_analises: true,
      ver_imposto: false,
      ver_relatorios: false,
      ver_timeline: false,
      buscar: false,
      gerar_darf: false,
      gerenciar_clientes: false,
      gerenciar_usuarios: false,
      ver_inteligencia: false,
    });
  }
  public static PermissoesColaborador() {
    return new Permissoes({
      calcular: true,
      incluir_nota: true,
      ver_analises: true,
      ver_imposto: true,
      ver_relatorios: true,
      ver_timeline: true,
      buscar: true,
      gerar_darf: true,
      gerenciar_clientes: true,
      gerenciar_usuarios: false,
      ver_inteligencia: true,
    });
  }
}

interface IPermissoes {
  ver_analises: boolean;
  ver_timeline: boolean;
  ver_imposto: boolean;
  gerar_darf: boolean;
  calcular: boolean;
  incluir_nota: boolean;
  ver_relatorios: boolean;
  buscar: boolean;
  gerenciar_usuarios: boolean;
  gerenciar_clientes: boolean;
  ver_inteligencia: boolean;
}
